import { CurrencyValue } from "@/components/tableElements";
import HelperMixin from "@/mixins/HelperMixin";
import AppIcon from "@/components/AppIcon";
import AppPopover from "@/components/AppPopover";
import ClockRewindIcon from "@/components/icons/ClockRewindIcon";
export default {
  name: "PpcBASBBudgetCell",
  emits: ["budget-change", "reset"],
  mixins: [HelperMixin],
  components: {
    CurrencyValue,
    AppIcon,
    AppPopover,
    ClockRewindIcon
  },
  props: {
    value: {
      type: Number
    },
    ai_value: {
      type: Number
    },
    currency_symbol: {
      type: String
    },
    currency: {
      type: String
    },
    currency_precision: {
      type: Number
    },
    loading: {
      type: Boolean
    },
    is_paused: Boolean,
    item_id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    aiValue() {
      return this.ai_value !== null && this.ai_value !== undefined;
    }
  },
  methods: {}
};